var _path, _path2, _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgManageRequest = function SvgManageRequest(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 86,
    viewBox: "0 0 95 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H79C87.5604 0.5 94.5 7.43959 94.5 16V70C94.5 78.5604 87.5604 85.5 79 85.5H16C7.43959 85.5 0.5 78.5604 0.5 70V16C0.500001 7.57345 7.22424 0.717247 15.5996 0.504883L16 0.5Z",
    fill: "url(#paint0_linear_7499_62366)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H79C87.5604 0.5 94.5 7.43959 94.5 16V70C94.5 78.5604 87.5604 85.5 79 85.5H16C7.43959 85.5 0.5 78.5604 0.5 70V16C0.500001 7.57345 7.22424 0.717247 15.5996 0.504883L16 0.5Z",
    stroke: "#E3AF32"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.7002,
    cy: 38,
    r: 7,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7499_62366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.4434 40.7402C58.4434 41.517 57.8138 42.1465 57.0371 42.1465C56.2607 42.1465 55.6309 41.517 55.6309 40.7402C55.6309 39.9639 56.2607 39.334 57.0371 39.334C57.8138 39.334 58.4434 39.9639 58.4434 40.7402Z",
    fill: "#E5B611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0359 25.7783C54.1813 25.7783 51.8657 28.0884 51.8657 30.9485V30.9503C51.8657 31.7267 52.4952 32.3558 53.272 32.3558C54.0487 32.3558 54.6782 31.7252 54.6782 30.9485C54.6782 29.6484 55.7296 28.5908 57.0377 28.5908C58.3385 28.5908 59.3969 29.6492 59.3969 30.9503C59.3969 32.2511 58.3385 33.3094 57.0377 33.3094C56.261 33.3094 55.6315 33.9393 55.6315 34.7157V36.2219C55.6315 36.9987 56.261 37.6282 57.0377 37.6282C57.8141 37.6282 58.444 36.9987 58.444 36.2219V35.9279C60.6145 35.3137 62.2094 33.3146 62.2094 30.9503C62.2094 28.0983 59.8894 25.7783 57.0359 25.7783Z",
    fill: "#E5B611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4941 54.8887C39.2417 53.5278 40.3689 51.406 40.3689 49.0249C40.3689 44.9274 37.0349 41.5938 32.9374 41.5938C28.8398 41.5938 25.5062 44.9274 25.5062 49.0249C25.5062 51.406 26.6334 53.5278 28.3806 54.8887C25.9146 56.3557 24 59.1265 24 62.5813V65.5938C24 66.3705 24.6295 67 25.4062 67H40.4689C41.2452 67 41.8751 66.3705 41.8751 65.5938V62.5813C41.8751 59.1272 39.9609 56.3561 37.4941 54.8887ZM28.3187 49.0249C28.3187 46.4783 30.3907 44.4062 32.9377 44.4062C35.4844 44.4062 37.5564 46.4783 37.5564 49.0249C37.5564 51.5719 35.4844 53.6439 32.9377 53.6439C30.3907 53.6439 28.3187 51.5719 28.3187 49.0249ZM39.0626 64.1875H26.8125V62.5813C26.8125 59.1982 29.5496 56.4564 32.9374 56.4564C36.3204 56.4564 39.0623 59.1935 39.0623 62.5813V64.1875H39.0626Z",
    fill: "#E5B611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0752 19H48.0001C44.7277 19 42.0752 21.6477 42.0752 24.9249V52.0374C42.0752 53.1876 43.3943 53.8604 44.3252 53.1624L49.9751 48.9249H66.0752C69.3477 48.9249 72.0001 46.2772 72.0001 43V24.9249C72.0001 21.6525 69.3524 19 66.0752 19ZM69.1876 43C69.1876 44.7205 67.7964 46.1124 66.0752 46.1124H49.5063C49.202 46.1124 48.9061 46.2113 48.6626 46.3937L44.8877 49.2249V24.9249C44.8877 23.2045 46.2789 21.8125 48.0001 21.8125H66.0752C67.7957 21.8125 69.1876 23.2037 69.1876 24.9249V43Z",
    fill: "#E5B611"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7499_62366",
    x1: 54.749,
    y1: 56.1891,
    x2: 144.433,
    y2: 134.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3BD21"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7499_62366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(24 19)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgManageRequest);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/manage_request.d3b4aa181c21564e85797049b58d44d7.svg";